import React from 'react';

const DefaultFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1550_80197)">
      <path d="M10 2.5V5.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 14.5V17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.69922 4.69727L6.82172 6.81977" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.1797 13.1797L15.3022 15.3022" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 10H5.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 10H17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.69922 15.3022L6.82172 13.1797" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.1797 6.81977L15.3022 4.69727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1550_80197">
        <rect width="18" height="18" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default DefaultFilterIcon;
